import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const StickyBackButton: React.FC = () => {
  const navigate = useNavigate();

  const onBack = useCallback(() => {
    // `navigate(-1)` is best when there's real browser history.
    // If the user landed directly on a deep link, fall back to app root.
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div
      className="fixed left-4 top-16 z-[45]"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      <button
        type="button"
        onClick={onBack}
        className="inline-flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white/95 px-3 text-sm font-semibold text-slate-800 shadow-md backdrop-blur hover:bg-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        aria-label="กลับ"
      >
        <ArrowLeft className="h-4 w-4" strokeWidth={2.5} aria-hidden />
        <span>กลับ</span>
      </button>
    </div>
  );
};

